import { useEffect } from 'react';

import { motion, AnimatePresence } from 'framer-motion';

import useMode from '../stores/mode';
import useNavigation from '../stores/navigation';

const transitions = {
    hidden: {
        y: -24,
        opacity: 0,
        transition: {
            ease: 'circIn',
            duration: 0.2,
        },
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            ease: 'circOut',
            duration: 0.3,
        },
    },
};

function Navigation() {
    const mode = useMode();
    const navigation = useNavigation();

    useEffect(() => {
        navigation.close();
    }, [mode.mode]);

    return (
        <AnimatePresence initial={false}>
            {navigation.isOpen && (
                <motion.section
                    className={`Navigation ${navigation.isOpen ? 'open' : 'closed'}`}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={transitions}
                >
                    <nav className="Navigation-list">
                        <a
                            onClick={() => {
                                mode.set('index');
                                navigation.close();
                            }}
                        >
                            Index
                        </a>
                        <a href="https://global-diplomacy-lab.org/imprint/">Imprint</a>
                    </nav>
                </motion.section>
            )}
        </AnimatePresence>
    );
}

function NavigationToggle() {
    const navigation = useNavigation();

    return (
        <button
            className={`NavigationToggle ${navigation.isOpen ? 'open' : 'closed'}`}
            onClick={() => navigation.toggle()}
        >
            Open Navigation
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
        </button>
    );
}

export { Navigation, NavigationToggle };
